// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import classNames from 'classnames';
import useDarkMode from '../../../hooks/useDarkMode';
import Footer from '../../../layout/Footer/Footer';

const DefaultFooter = () => {
	const { darkModeStatus } = useDarkMode();

	return (
		<Footer>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col'>
						<span className='fw-light'>
							{/* Show "GIFC" on mobile, full name on desktop */}
							<span className='d-none d-md-inline'>
								© 2025 Globe Investment and Fintech Company Limited
							</span>
							<span className='d-inline d-md-none'>© 2025 GIFC</span>
						</span>
					</div>
					<div className='col-auto'>
						Developed by:{' '}
						<a
							href='#'
							className={classNames('text-decoration-none', {
								'link-dark': !darkModeStatus,
								'link-light': darkModeStatus,
							})}>
							<small className='fw-bold'>Dimik Infotech Ltd.</small>
						</a>
					</div>
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
